import { createAsyncThunk } from "@reduxjs/toolkit";
import { CollaboratorService } from "../../services";
import {
  createCRUDThunksLegacy,
  handleAsyncThunkErrorLegacy,
} from "../../shared/helpers";
import {
  AxiosParams,
  ICollaborator,
  ICollaboratorBase,
} from "../../shared/types";

const service = new CollaboratorService();

const resourceName = "collaborators";
const fetchCollaboratorsForWeb = createAsyncThunk(
  `${resourceName}/fetchCollaboratorsForWeb`,
  async (params: AxiosParams | undefined = {}, { rejectWithValue }) => {
    try {
      const data = await service.getCollaboratorsForWeb();
      return data;
    } catch (error) {
      return handleAsyncThunkErrorLegacy(error, rejectWithValue);
    }
  }
);

const crudThunks = createCRUDThunksLegacy<ICollaborator, ICollaboratorBase>({
  service,
  resourceName,
});

export const collaboratorThunks = {
  ...crudThunks,
  fetchCollaboratorsForWeb,
};
